import React, { useContext } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components"
import colors from "../../utils/style/colors.tsx";
import { Titre, Texte } from "../../utils/style/elements.tsx"
import Youtube from "../../assets/images/logos/ytb-logo.png";
import GitHub from "../../assets/images/logos/gh-logo.png";
import Linkedin from "../../assets/images/logos/lkd-logo.png";
import Itch from "../../assets/images/logos/itch-logo.png";
import { LanguageContext } from "../../context/LanguageContext";
import contactTrad from "../../traductions/contact-trad.js";

const Main = styled.main``

const ContactContainer = styled.div``

const WrapperLogos = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 110px;

    @media (max-width: 900px) {
        gap: 70px;
    }

    @media (max-width: 768px) {
        gap: 30px;
    }
`

const ContainerLogos = styled.div`
    width: fit-content;
`

const StyledLink = styled(Link)``

const ImgLogos = styled.img`
    width: 100px;
    height: auto;

    @media (max-width: 768px) {
        width: 38px;
    }
`

const DownloadContainer = styled.div``

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 60px;
    margin-top: 50px;
`


const DownloadLink = styled.a`
    border: none;
    background-color: ${colors.red};
    color: white;
    font-weight: 500;
    padding: 6px 10px;
    width: 260px;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;

    transition: all ease 0.3s;
    box-shadow: 1px 1px 3px #4f4f4f;


    &:hover{
        transition: all ease 0.3s;
        box-shadow : inset 0px 0px 5px 10px #972121ff;
        box-shadow: 5px 5px 5px #4f4f4f;
        transform: translate(-5px, -5px);
    }

    @media (max-width: 768px) {
        width: 145px;
    }
`;

const StyledTitre = styled(Titre)`
    margin: 50px 0 20px;

    @media (max-width: 768px) {
        margin: 30px 0 15px;
    }
`


function Contact() {
    const { language } = useContext(LanguageContext);

    // Sélection du fichier en fonction de la langue
    const cvFile =
    language === "en"
        ? "/pdf/CV Dev - Anglais Alexandre Kotowicz 2026.pdf"
        : "/pdf/CV Dev Alexandre Kotowicz 2026.pdf";

        
    return (
        <Main>
            <ContactContainer>
                <StyledTitre>{contactTrad[language].reseaux}</StyledTitre>
                <WrapperLogos>
                    <ContainerLogos>
                        <StyledLink to="https://www.youtube.com/channel/UCf_GOXuzxP3zWIn8xGXD2NQ" target="_blank">
                            <ImgLogos src={Youtube} />
                        </StyledLink>
                    </ContainerLogos>

                    <ContainerLogos>
                        <StyledLink to="https://github.com/AlexandreKcz" target="_blank">
                            <ImgLogos src={GitHub} />
                        </StyledLink>
                    </ContainerLogos>

                    <ContainerLogos>
                        <StyledLink to="https://www.linkedin.com/in/alexandre-kotowicz-785739214/?originalSubdomain=fr" target="_blank">
                            <ImgLogos src={Linkedin} />
                        </StyledLink>
                    </ContainerLogos>

                    <ContainerLogos>
                        <StyledLink to="https://alexandre-kotowicz.itch.io/" target="_blank">
                            <ImgLogos src={Itch} />
                        </StyledLink>
                    </ContainerLogos>
                </WrapperLogos>
            </ContactContainer>

            <DownloadContainer>
                <Titre>{contactTrad[language].contact}</Titre>
                <Texte>
                {contactTrad[language].texte} 
                <a href="mailto:alexandre.kcz.pro@gmail.com" style={{ textDecoration: "none" }}>
                    alexandre.kcz.pro@gmail.com
                </a>
                </Texte>
                <ButtonContainer>
                    <DownloadLink href={cvFile} download>
                        <Texte>{contactTrad[language].bouton} <b>↧</b></Texte>
                    </DownloadLink>
                </ButtonContainer>
            </DownloadContainer>
        </Main>
    )
}

export default Contact
